import { useQuery } from '@apollo/client';

import type { UserFormDataType } from '@xing-com/crate-jobs-domain-apply-types';
import { GetUserEmailWithPhoneFallbackDocument } from '@xing-com/crate-jobs-graphql';
import { useViewerData } from '@xing-com/hub';

import { getUserPhoneData } from './get-user-phone-data';

type UseUserEmailWithPhoneFallbackValue = {
  isUserEmailError: boolean;
  isUserEmailLoading: boolean;
  userFormData: UserFormDataType;
};

export const useUserEmailWithPhoneFallback = (
  isLoggedIn: boolean
): UseUserEmailWithPhoneFallbackValue => {
  const { loading: isViewerDataLoading, data: viewerData } = useViewerData();
  const userId = viewerData?.user?.id;
  const { error, loading, data } = useQuery(
    GetUserEmailWithPhoneFallbackDocument,
    { skip: !isLoggedIn || !userId, variables: { userId: userId ?? '0' } }
  );
  const accountSettings = data?.viewer?.accountSettings;
  const privateContactDetails =
    data?.profileModules?.xingIdModule?.contactDetails?.private;
  const userEmail = accountSettings?.email?.active;
  const userPhone = getUserPhoneData(
    accountSettings?.phone?.active,
    privateContactDetails
  );

  return {
    isUserEmailError:
      !!error || (isLoggedIn && !loading && !isViewerDataLoading && !userEmail),
    isUserEmailLoading: loading || isViewerDataLoading,
    userFormData: {
      userEmail,
      userPhone,
    },
  };
};
